import { render } from "./GetCourseForm.vue?vue&type=template&id=d1fe9488&scoped=true"
import script from "./GetCourseForm.vue?vue&type=script&lang=js"
export * from "./GetCourseForm.vue?vue&type=script&lang=js"

import "./GetCourseForm.vue?vue&type=style&index=0&id=d1fe9488&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fe9488"]])

export default __exports__